import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@mui/material/Typography';

import s from './TextDeprecated.css';

const Text = ({ children, ...restProps }) => (
  <Typography
    classes={{
      body1: s.body1,
      body2: s.body2,
      button: s.button,
      caption: s.caption,
      h1: s.h1,
      h2: s.h2,
      h3: s.h3,
      h4: s.h4,
      h5: s.h5,
      h6: s.h6,
      overline: s.overline,
      subtitle1: s.subtitle1,
      subtitle2: s.subtitle2,
    }}
    {...restProps}
  >
    {children}
  </Typography>
);

Text.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Text;
